module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-1"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "normal",
      "font-size": "12.92em",
      "color": "#7096CE"
    }
  }, [_vm._v("Biloxi")])]), _vm._v(" "), _c('p', {
    staticClass: "P_div_frame-2"
  }, [_c('span', [_c('img', {
    staticClass: "frame-4",
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "14461.jpg",
      "id": "a_14461",
      "src": "14461.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34e75ce9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0006.vue
// module id = 72
// module chunks = 0